import staticUrls from "./staticUrls";

const circuitRootUrl = "site";

const getCircuitUrl = (siteId, zoneId) => `${circuitRootUrl}/${siteId}/zone/${zoneId}/Circuit`;

const getCircuitsListUrl = (siteId, zoneId) => `${getCircuitUrl(siteId, zoneId)}/list`;

const getCircuitCategoriesUrl = () => `${staticUrls.staticRootUrl}/circuitCategories`;

const getCircuitPowerUrl = (siteId, zoneId, circuitId) => `site/${siteId}/zone/${zoneId}/circuit/${circuitId}/power`;

const getCircuitDemandUrl = (siteId, zoneId, circuitId) => `site/${siteId}/zone/${zoneId}/circuit/${circuitId}/demand`;

export default {
  getCircuitUrl,
  circuitRootUrl,
  getCircuitsListUrl,
  getCircuitCategoriesUrl,
  getCircuitPowerUrl,
  getCircuitDemandUrl
};
